import { Tooltip } from "bootstrap";
import SlimSelect from "slim-select";
import Glide from "@glidejs/glide";
import { Fancybox } from "@fancyapps/ui";
import Mask from "@tadashi/mask";
import Alpine from "alpinejs";
import documentReady from "./helpers/documentReady";
import "./header";
import "./solutions";
import "./hr";
import "./products";
import "./products.detail";
import "./support";
import "./contacts";
import "./hover.mobile";
import "./datapicker";
import YMap from "./y-map";
import watcherBtn from "./pay";
import { settingSL, eventsSliderRunSL, mountMutateSL } from "./slider-laps";
import "./tabs-hash";
import InputList from "./input-list";

window.Alpine = Alpine;
Alpine.start();

new InputList();

/** Активирует всплывающие подсказки * */
const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
tooltipTriggerList.map((tooltipTriggerEl) => new Tooltip(tooltipTriggerEl));
/** Активирует всплывающие подсказки * */

/** Стандартный слайдер glide --- * */
if (document.querySelector(".glide")) {
	new Glide(".glide").mount();
}

if (document.querySelector(".glide-autoplay")) {
	new Glide(".glide-autoplay", { autoplay: 7000, gap: 0 }).mount();
}
/** --- Стандартный слайдер glide * */

/** Слайдеры с прогресс баром --- * */
document.querySelectorAll(".slider-laps").forEach((slider) => {
	const countView = slider.getAttribute("data-count-view");
	const setting = { ...settingSL };

	if (countView) {
		setting.perView = +countView;
	}

	const sliderLaps = new Glide(slider, setting);
	sliderLaps
		.on(["mount.after", "run"], () => eventsSliderRunSL(sliderLaps))
		.mount({ mountMutateSL });
});
/** --- Слайдеры с прогресс баром * */

/** Скролл по якорным ссылкам с учетом элементов с классом '.js-margin-scroll' */
const anchors = document.querySelectorAll('a[href*="#"]');

documentReady(() => {
	anchors.forEach((anchor) => {
		anchor.addEventListener("click", function (e) {
			if (!document.getElementById(this.getAttribute("href").substr(1))) return;
			e.preventDefault();

			const $blockTo = document.getElementById(this.getAttribute("href").substr(1));
			const marginScroll = Array.from(document.querySelectorAll(".js-margin-scroll")).map((item) => item.offsetHeight).reduce((prev, current) => prev + current) || 0;

			window.scrollTo({ top: $blockTo.offsetTop - marginScroll, behavior: "smooth" });
		});
	});
});
/** --- Скролл по якорным ссылкам с учетом элементов с классом '.js-margin-scroll' */

/** Инициализация карт * */
Array.from(document.querySelectorAll(".map-box")).forEach((map) => new YMap(map.getAttribute("id"), watcherBtn));
/** --- Инициализация карт * */

/** Оборачивание картинок детальной страницы */
if (document.querySelector(".page-content img.detail__image")) {
	document.querySelectorAll(".page-content img.detail__image").forEach((img) => {
		const imgSrc = img.getAttribute("src");
		const imgTitle = img.getAttribute("title");
		const imageWrapper = document.createElement("a");

		imageWrapper.classList.add("detail__image");
		imageWrapper.dataset.fancybox = "detail-images";
		imageWrapper.innerHTML = `<figure><img src="${imgSrc}" title="${imgTitle || ""}" class="detail__image" alt=""><figcaption>${imgTitle || ""}</figcaption></figure>`;
		imageWrapper.href = imgSrc;

		img.replaceWith(imageWrapper);
	});
	Fancybox.bind("[data-fancybox=\"detail-images\"]");
}
/** Оборачивание картинок детальной страницы */

/** Добавление слайдера изображений и видео * */
if (document.querySelector("[data-fancybox]")) {
	Fancybox.bind("[data-fancybox]");
}
/** --- Добавление слайдера изображений и видео * */

/** Select с поиском * */
if (document.querySelector(".select-search")) {
	document.querySelectorAll(".select-search").forEach((i) => {
		const ss = new SlimSelect({
			select: i,
			settings: {
				searchPlaceholder: "Поиск",
				searchText: "Ничего не найдено",
			},
			events: {
				afterChange: (newVal) => {
					i.form.submit();
				},
			},
		});
		if (i.querySelector("option[selected]")) {
			ss.setSelected(i.querySelector("option[selected]").value);
		}
	});
}
/** --- Select с поиском * */

/** --- Select с поиском для страницы Сервис и гарантия * */
const serviceSelect = new SlimSelect({
	select: "#select-search-duplicate-pass",
	settings: {
		searchPlaceholder: "Поиск",
		searchText: "Ничего не найдено",
	},
});
/** --- Select с поиском для страницы Сервис и гарантия * */

/** --- Очистка форм в модалках на странице Сервис и гарантия * */
const modalRecStat = document.getElementById("service-reclamation-status-modal");
if (modalRecStat) {
	modalRecStat.addEventListener("hidden.bs.modal", (event) => {
		event.target.querySelector("form").reset();
	});
}

const modalPassDuplicate = document.getElementById("service-duplicate-pass-modal");
if (modalPassDuplicate) {
	modalPassDuplicate.addEventListener("hidden.bs.modal", (event) => {
		event.target.querySelector("form").reset();
		if (serviceSelect) serviceSelect.setSelected("");
	});
}
/** --- end Очистка форм в модалках на странице Сервис и гарантия * */

/** Показывает элементы фильтрации* */
if (document.querySelector("[data-show-items]")) {
	document.querySelectorAll("[data-show-items]").forEach((btnShowItems) => {
		btnShowItems.addEventListener("click", (e) => {
			e.preventDefault();
			const id = e.target.dataset.showItems;
			const $wrapperItems = document.querySelector(id);

			if ($wrapperItems) {
				$wrapperItems.querySelectorAll(".d-none").forEach((item) => item.classList.remove("d-none"));
				btnShowItems.classList.add("d-none");
			}
		});
	});
}
/** Показывает элементы фильтрации * */

/** Маска на инпуты --- */
document.querySelectorAll(`[data-mask]`).forEach((i) => new Mask(i));
/** --- Маска на инпуты */
